import React from 'react'

const PercentageBar = ({ percentage, color }) => {
  return (
    <div className="relative overflow-hidden bg-gray-200 percentage-bar border-1 rounded-xl">
      <div
        className="relative z-20 text-sm text-white percentage-bar__percentage"
        style={{ padding: '3px 6px', textShadow: '1px 1px 1px black' }}>
        {percentage}%
      </div>

      <div
        className="absolute top-0 percentage-bar__bar"
        style={{
          width: `${percentage}%`,
          height: '100%',
          backgroundColor: color,
        }}
      />
    </div>
  )
}

export default PercentageBar
